function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "347a516f-b616-42cd-bca2-6cfbf586638c",
  x1: 572.9,
  y1: 755.08,
  x2: 572.9,
  y2: 525.34,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "e00253b5-e5fd-466b-b4ee-95920ce01953",
  x1: 438.37,
  y1: 495.2,
  x2: 438.37,
  y2: 0,
  xlinkHref: "#347a516f-b616-42cd-bca2-6cfbf586638c"
}), React.createElement("linearGradient", {
  id: "ab06724f-bdb5-49a8-9523-33f733941f87",
  x1: 976.2,
  y1: 709.03,
  x2: 976.2,
  y2: 305.16,
  xlinkHref: "#347a516f-b616-42cd-bca2-6cfbf586638c"
}), React.createElement("linearGradient", {
  id: "5a176c23-bf11-4e32-afb4-461b4082aabc",
  x1: 687.77,
  y1: 477.59,
  x2: 687.77,
  y2: 422.25,
  xlinkHref: "#347a516f-b616-42cd-bca2-6cfbf586638c"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "website setup");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1018.36,667.17c-1.72-7.1-7.37-12.45-11.53-18.46a50,50,0,0,1-3.07-50.73c4-7.61,10.27-15.48,8-23.79-1.52-5.59-6.57-9.42-11.53-12.42a112.83,112.83,0,0,0-62.57-16.09c-26.94,1.1-53.79,11.86-80.21,6.53C831.72,547,809.92,534.1,783,532.57c-20.11-1.14-40,.14-60.15-2.06a891.8,891.8,0,0,0-149.93-3.58A891.8,891.8,0,0,0,423,530.51c-20.1,2.2-40,.92-60.15,2.06-27,1.52-48.75,14.44-74.49,19.64-26.43,5.34-53.27-5.43-80.21-6.53a112.83,112.83,0,0,0-62.57,16.09c-5,3-10,6.83-11.53,12.42-2.26,8.3,4,16.17,8,23.79A50,50,0,0,1,139,648.71c-4.16,6-9.81,11.36-11.53,18.46-3.46,14.28,10.42,26.86,24,32.53,37.05,15.49,82.11,8,116,29.57,15.19,9.68,28.48,25.22,46.48,25.8,12.17.39,23.24-6.37,33.87-12.32a324.75,324.75,0,0,1,49.71-22.57c15-5.34,30.89-9.62,46.72-7.85C468.42,715,572.9,765.48,620,735.65c32.26-20.45,57.42-20.62,81.65-23.33,15.83-1.77,31.71,2.51,46.72,7.85a324.75,324.75,0,0,1,49.71,22.57c10.62,5.95,21.7,12.71,33.87,12.32,18-.58,31.29-16.12,46.48-25.8,33.87-21.58,78.92-14.08,116-29.57C1007.94,694,1021.83,681.46,1018.36,667.17Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.5,
  fill: "url(#347a516f-b616-42cd-bca2-6cfbf586638c)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1013.46,666.88c-1.7-7-7.29-12.32-11.4-18.26a49.49,49.49,0,0,1-3-50.17c4-7.53,10.16-15.31,7.92-23.52-1.51-5.53-6.5-9.32-11.4-12.28a111.59,111.59,0,0,0-61.88-15.92c-26.64,1.08-53.19,11.73-79.33,6.45-25.46-5.14-47-17.92-73.67-19.43-19.89-1.12-39.6.14-59.48-2a882,882,0,0,0-148.28-3.54,882,882,0,0,0-148.28,3.54c-19.88,2.18-39.59.91-59.48,2-26.66,1.5-48.21,14.28-73.67,19.43-26.13,5.28-52.69-5.37-79.33-6.45a111.59,111.59,0,0,0-61.88,15.92c-4.9,3-9.89,6.75-11.4,12.28-2.24,8.21,4,16,7.92,23.52a49.49,49.49,0,0,1-3,50.17c-4.12,5.94-9.7,11.23-11.4,18.26C128.91,681,142.64,693.44,156.05,699c36.65,15.31,81.21,7.9,114.7,29.24,15,9.57,28.17,24.95,46,25.52,12,.39,23-6.3,33.5-12.19a321.18,321.18,0,0,1,49.17-22.33c14.85-5.29,30.55-9.52,46.21-7.77,24,2.68,127.3,52.57,173.84,23.07,31.91-20.22,56.79-20.39,80.75-23.07,15.66-1.75,31.37,2.48,46.21,7.77a321.18,321.18,0,0,1,49.17,22.33c10.51,5.88,21.46,12.57,33.5,12.19,17.8-.57,30.95-15.94,46-25.52,33.5-21.34,78.06-13.93,114.7-29.24C1003.16,693.44,1016.89,681,1013.46,666.88Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159,364.14c2.86-1,5.9-1.95,8.89-1.43,5,.87,8.51,5.61,10,10.48s1.44,10,2.39,15,3.22,10.17,7.7,12.56,9.77,1.45,14.74.87a93.08,93.08,0,0,1,19.63-.18c5.48.53,11.92,2.38,13.53,7.65,1.32,4.3-1.3,8.69-3,12.84-3.26,7.76-3.52,16.93.21,24.47s11.29,13.16,14.45,21.12a10.44,10.44,0,0,1,.76,6.37,11.62,11.62,0,0,1-2.26,4.1c-2.48,3.19-5.44,6-7.7,9.36-4.71,7-6,15.7-6.54,24.11a175.8,175.8,0,0,0,.14,24.83c-6.14-2-12.92-.22-19.25-1.53-13.47-2.78-21.88-18.72-35.6-19.69-6.49-.46-13.47,2.6-19.26-.37a14.54,14.54,0,0,1-6.16-7A24.84,24.84,0,0,1,150.09,491c1-3.86,3-7.64,2.61-11.61-.33-3.4-2.37-6.4-4.71-8.89-6.67-7.08-16.35-11.41-21.14-19.88a22.65,22.65,0,0,1,2.69-25.49,66.9,66.9,0,0,0,4.85-5.27c2.3-3.24,3-7.33,3.31-11.3.66-9.51-1-19.58,2.11-28.82C142.6,371.38,151.12,366.94,159,364.14Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0",
  opacity: 0.6
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M159.14,364.42s27.31,151.67,62.77,169.76",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M235.12,406.4s-29.25,4-58.47,34.05",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M181.79,458.07s-22.51-22-57.68-18.27",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M248,467.64s-41.08,3.49-56.29,19.26",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.86,501.59s-23-4-44.23,9.55",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1004.49,245c-4.59-1.63-9.46-3.12-14.25-2.29-8,1.4-13.64,9-16,16.79s-2.31,16.1-3.83,24.1-5.16,16.29-12.34,20.13-15.66,2.32-23.63,1.4A149.21,149.21,0,0,0,903,304.8c-8.79.85-19.1,3.82-21.68,12.26-2.11,6.9,2.08,13.92,4.88,20.57,5.23,12.43,5.65,27.14-.34,39.23-6.09,12.3-18.1,21.1-23.16,33.85-1.28,3.24-2.09,6.83-1.22,10.2a18.63,18.63,0,0,0,3.63,6.58c4,5.12,8.72,9.63,12.34,15,7.55,11.2,9.6,25.16,10.48,38.64a281.8,281.8,0,0,1-.22,39.79c9.84-3.24,20.72-.35,30.86-2.44,21.59-4.45,35.07-30,57.06-31.56,10.4-.73,21.59,4.16,30.87-.6,4.52-2.32,7.73-6.65,9.88-11.26a39.82,39.82,0,0,0,2.39-26.7c-1.63-6.19-4.8-12.24-4.18-18.61.53-5.45,3.79-10.26,7.55-14.24,10.69-11.35,26.21-18.29,33.89-31.86,7.2-12.72,5.38-29.93-4.31-40.86-2.54-2.87-5.56-5.33-7.78-8.45-3.69-5.19-4.87-11.75-5.31-18.11-1.05-15.25,1.54-31.38-3.39-46.19C1030.74,256.56,1017.09,249.43,1004.49,245Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0",
  opacity: 0.6
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1004.23,245.4s-43.77,243.11-100.62,272.1",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M882.44,312.69s46.88,6.44,93.72,54.59",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M967.92,395.51s36.09-35.29,92.45-29.29",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M861.85,410.85s65.84,5.59,90.22,30.88",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M942.17,465.27s36.89-6.46,70.9,15.3",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#535461",
  strokeMiterlimit: 10,
  opacity: 0.6
});

var _ref18 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "74.91 0 74.91 24.99 74.91 495.2 801.84 495.2 801.84 24.99 801.84 0 74.91 0",
  fill: "url(#e00253b5-e5fd-466b-b4ee-95920ce01953)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 85.69,
  y: 22.47,
  width: 708.45,
  height: 463.77,
  fill: "#fff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 85.69,
  y: 0.41,
  width: 708.45,
  height: 34.12,
  fill: "#eee"
});

var _ref21 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 112.65,
  cy: 16.95,
  r: 8.27,
  fill: "#ff5252"
});

var _ref22 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 135.4,
  cy: 16.95,
  r: 8.27,
  fill: "#ff0"
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 158.15,
  cy: 16.95,
  r: 8.27,
  fill: "#69f0ae"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 112.84,
  y: 89.18,
  width: 264,
  height: 11,
  fill: "#4527a0",
  opacity: 0.5
});

var _ref25 =
/*#__PURE__*/
React.createElement("rect", {
  x: 112.84,
  y: 111.18,
  width: 264,
  height: 11,
  fill: "#4527a0",
  opacity: 0.5
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 112.84,
  y: 133.18,
  width: 264,
  height: 11,
  fill: "#4527a0",
  opacity: 0.5
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 203.84,
  y: 155.18,
  width: 173,
  height: 11,
  fill: "#4527a0",
  opacity: 0.5
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 112.84,
  y: 177.18,
  width: 139,
  height: 11,
  fill: "#4527a0",
  opacity: 0.5
});

var _ref29 =
/*#__PURE__*/
React.createElement("rect", {
  x: 187.84,
  y: 199.18,
  width: 107,
  height: 11,
  fill: "#4527a0",
  opacity: 0.5
});

var _ref30 =
/*#__PURE__*/
React.createElement("rect", {
  x: 411.84,
  y: 166.18,
  width: 311,
  height: 179,
  fill: "#4527a0",
  opacity: 0.5
});

var _ref31 =
/*#__PURE__*/
React.createElement("rect", {
  x: 448.84,
  y: 183.18,
  width: 311,
  height: 179,
  fill: "#eee"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1070.88,493.24a4.71,4.71,0,0,0,1-2.89s0-.06,0-.08.06-.21.09-.31l0-.13a2.88,2.88,0,0,0,0-.29s0-.08,0-.12a2,2,0,0,0,0-.36c-.59-4-24.36-30.06-30.3-61.85a56.21,56.21,0,0,0-2.93-10.13,14,14,0,0,0-.32-4.9c-1-4.07-3-8.2-2-12.26a9.9,9.9,0,0,1,.55-1.55,60.59,60.59,0,0,0,3.43-5.69,13.74,13.74,0,0,0,1-2c3.65-9.62-7.65-19.55-5.57-29.59.9-4.35,4.27-8.15,4.18-12.58-.11-5.07-4.77-9-9.61-10.88s-10.17-2.42-14.92-4.52c-10.41-4.61-16.11-15.74-25.61-21.93-12.07-7.85-27.82-6.45-42.29-4.42a2.93,2.93,0,0,0-2.22,1.64h0l-.14,0c-.11.32-.24.63-.38.94-2,3.41-5.37,6-8.7,8.39-4.06,2.86-8.41,5.68-10.89,9.92-.37.63-.68,1.23-.95,1.81-5.4,9.63,1.09,13.79,9,16.1a24.9,24.9,0,0,0-.36,4.17c0,14,11.71,25.43,26.14,25.43a27.07,27.07,0,0,0,3.41-.22l.84.55.19,0c2.68,1.93,5,4.35,6,7.23l-8.38,6.4s.34.88.84,2.28l-32.94,15.18c-12.48.58-32.68-38.73-32.68-38.73s-3-22.54-13.67-26.59c-3.22-1.22-4.5,1.33-4.72,5.49-4.77,5,3.24,33.08,3.24,33.08l25.55,45.09c2.38,4.62,3,7.51,14.26,9.25,9.27,1.42,38.15-8.84,48.2-12.56l.47,4a23.43,23.43,0,0,0-1.52,9.57c0,7.37,3.29,18.09,19.35,26.63,0,0,16.58,21.43,14.74,41.66,0,0,.8.84,2.08,1.94-.18,5.7-1,12.73-3.87,15.47a1.53,1.53,0,0,0-.45,1.42,1.45,1.45,0,0,0,.7,1.55l-20.93,36.65c-.78,1-1.57,2-2.38,3a107.29,107.29,0,0,1-12.89,13.75c-3.49,3.11-7.12,6.51-7.84,7.78-1.11,2-3.9,8.45-2.72,13.78a72,72,0,0,1,1.86,19.74l-2.71,47.41a123.66,123.66,0,0,1-3.75,15.65l-.41,0s-10.1,12.14-26.14,15-15.45,11-10.7,12.14,62.39-1.16,62.39-1.16,2.18-4.25,1.58-8.13c18.4-1.77,43.89-4.77,43.89-4.77s3.49-8.39-1.58-12.05a11.84,11.84,0,0,1-4.06-5.77c-.3-1.28-.63-2.74-.95-4.27-.08-.75-.08-1.21-.08-1.21h-.17c-.89-4.47-1.6-9.26-1.19-11.77,1.49-6.65,5.35-45.09-4.16-56.07-4.32-5-3.73-10.68-1.81-15.42,11.41-7.47,27.37-23.54,36.6-33.26.52.43,1,.86,1.45,1.29l.3.29s31.41-15.55,31.54-43A42.31,42.31,0,0,0,1070.88,493.24ZM970.27,686.88a16.14,16.14,0,0,1,.11-3l-1-.11c.58-4.36,2-9.24,5.18-12.61A107.1,107.1,0,0,0,986,639.48l5.77,21.83s.58,4.52.74,9.3h-.1S984.36,682.1,970.27,686.88Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.5,
  fill: "url(#ab06724f-bdb5-49a8-9523-33f733941f87)"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M996.35,404.14s-14.11,5.08-22,13.55c0,0-38.39,15.24-49.12,13.55s-11.29-4.52-13.55-9l-24.28-44s-10.16-36.7,0-32.75,13,26,13,26,19.2,38.39,31.05,37.83L963.6,394s7.34-10.73,10.73-10.16S996.35,404.14,996.35,404.14Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref34 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.05
}, React.createElement("path", {
  d: "M996.35,404.14s-14.11,5.08-22,13.55c0,0-38.39,15.24-49.12,13.55s-11.29-4.52-13.55-9l-24.28-44s-10.16-36.7,0-32.75,13,26,13,26,19.2,38.39,31.05,37.83L963.6,394s7.34-10.73,10.73-10.16S996.35,404.14,996.35,404.14Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M973.17,383.33l-11.26,8.84s5.63,14.73,4.22,19.89,22.52-8.1,22.52-8.1l-9.85-22.1Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f9ce43"
});

var _ref36 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.05
}, React.createElement("path", {
  d: "M973.17,383.33l-11.26,8.84s5.63,14.73,4.22,19.89,22.52-8.1,22.52-8.1l-9.85-22.1Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.73,373.49s25.12,8.19,13.55,22.58l36.13-17.5s-15.24,1.13-24.84-22Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1001.15,520.85,970.1,576.74,991,658s2.26,18.07-1.13,19.76h23.71s-4.57-16-3.39-21.45c1.41-6.49,5.08-44-4-54.76s4.52-24.84,4.52-24.84l27.1-42.91Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref39 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.05
}, React.createElement("path", {
  d: "M1001.15,520.85,970.1,576.74,991,658s2.26,18.07-1.13,19.76h23.71s-4.23-16.09-3.39-21.45,5.08-44-4-54.76,4.52-24.84,4.52-24.84l27.1-42.91Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M991.6,667.12S983,679.79,968,683.81s-13.78,11.86-9.19,12.62,59-5.83,59-5.83,3.31-8.19-1.5-11.77-4.84-11-4.84-11Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#0d134d"
});

var _ref41 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M1002.85,498.26s1.34,18.36-3.55,23.18a1.48,1.48,0,0,0,.3,2.38l14.54,7.75,13-24.84Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1002.85,497.7s1.34,18.36-3.55,23.18a1.48,1.48,0,0,0,.3,2.38l14.54,7.75,13-24.84Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#e23553"
});

var _ref43 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M1002.85,498.7s1.34,18.36-3.55,23.18a1.48,1.48,0,0,0,.3,2.38l14.54,7.75,13-24.84Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1003.41,533.83s-8.39,5.6-26,28.65a103.69,103.69,0,0,1-12.25,13.43c-3.31,3-6.76,6.36-7.45,7.6-1.06,1.91-3.71,8.26-2.58,13.46a72.26,72.26,0,0,1,1.77,19.28l-2.57,46.31s-3.39,20.89-7.9,23.15l23.15,4s-1.69-14.68,5.08-22c0,0,15.81-27.1,11.86-57.59,0,0-1.69-13.55,13.55-20.89s46.3-42.91,46.3-42.91Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M950.34,677.8s-9.6,11.86-24.84,14.68-14.68,10.73-10.16,11.86,59.28-1.13,59.28-1.13,4-7.9-.56-11.86-3.39-11.29-3.39-11.29Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#0d134d"
});

var _ref46 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M1017.53,503.91s-6.89,23.14-15.62,29.88a1.12,1.12,0,0,0,.29,1.95c7.22,2.63,30.42,11.49,38.48,19.55l.28.28s48.27-24.56,22.3-66.34Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1017.53,503.35s-6.89,23.14-15.62,29.88a1.12,1.12,0,0,0,.29,1.95c7.22,2.63,30.42,11.49,38.48,19.55l.28.28s48.27-24.56,22.3-66.34Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#e23553"
});

var _ref48 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M977.89,388.61a44.17,44.17,0,0,1-11.64,5.56l3.88,34.53S961.06,449,987,463.18c0,0,15.75,20.93,14,40.69,0,0,8.45,9.06,14.1,6.81s.56,1.13,1.69.57,3.38,4.53,20.89.05,30-16.29,29.41-20.25-23.07-29.42-28.64-60.49-38.82-53.17-38.82-53.17-1.1.61-3,1.42A131.47,131.47,0,0,0,977.89,388.61Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref49 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M1001.47,534a1.1,1.1,0,0,0,.73,1.13c6.22,2.27,24.3,9.16,34.34,16.18C1027.85,544.29,1009.36,537,1001.47,534Z",
  transform: "translate(-124.06 -144.92)"
}), React.createElement("path", {
  d: "M1063.26,488.67l-1,.34c22.19,38.79-19.6,62.22-23.25,64.17.63.52,1.2,1,1.72,1.55l.28.28S1089.23,530.45,1063.26,488.67Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1037.85,510.12c-17.5,4.52-19.76-.56-20.89,0s4-2.82-1.69-.56-14.11-6.78-14.11-6.78c.08-1,.12-1.93.12-2.9C1001.34,481,987,462.13,987,462.13c-26-14.11-16.94-34.44-16.94-34.44L969,418.43l-2.91-25.26a44.12,44.12,0,0,0,11.62-5.58,132.18,132.18,0,0,1,18.71-9.84c1.91-.82,3-1.43,3-1.43s33.31,22,39,53.07,28.23,56.46,28.79,60.41S1055.35,505.6,1037.85,510.12Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f9ce43"
});

var _ref51 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M979.13,357.12l-24.84,16.94a42.26,42.26,0,0,1,9.69,4.83c8.46-1.19,13.64-7.25,17.13-14.71C979.75,362,980.35,360.05,979.13,357.12Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref52 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 835.88,
  cy: 208.82,
  r: 24.84,
  fill: "#fdb797"
});

var _ref53 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M1041.8,507.3c-17.5,4.52-19.76-.56-20.89,0s4-2.82-1.69-.56-14.11-6.78-14.11-6.78c.08-1,.12-1.93.12-2.9.07-18.85-14.24-37.75-14.24-37.75-26-14.11-16.94-34.44-16.94-34.44L973,415.6l-2.75-23.91a27.34,27.34,0,0,1-4.11,1.47L969,418.43l1.07,9.26s-9,20.33,16.94,34.44c0,0,14.31,18.9,14.24,37.75,0,1,0,1.93-.12,2.9,0,0,8.47,9,14.11,6.78s.56,1.13,1.69.56,3.39,4.52,20.89,0a60.63,60.63,0,0,0,21.87-10.71A61.55,61.55,0,0,1,1041.8,507.3Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M994.94,409.06s-14.11,5.08-22,13.55c0,0-38.39,15.24-49.12,13.55s-11.29-4.52-13.55-9l-24.28-44s-10.16-36.7,0-32.75,13,26,13,26,19.2,38.39,31.05,37.83L962.2,398.9s7.34-10.73,10.73-10.16S994.94,409.06,994.94,409.06Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref55 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M975.88,388.39s-11.71-1.07-15.1,13.61,26,23.71,26,23.71l15.81-22Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M976.45,388.39s-11.71-1.07-15.1,13.61,26,23.71,26,23.71l15.81-22Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f9ce43"
});

var _ref57 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M971.67,391a30.31,30.31,0,0,1-5.54,2.14l.1.85A58.37,58.37,0,0,0,971.67,391Z",
  transform: "translate(-124.06 -144.92)"
}), React.createElement("path", {
  d: "M1067.21,489.8c-.56-4-23.15-29.36-28.79-60.41s-39-53.07-39-53.07-1.1.61-3,1.43a135.42,135.42,0,0,0-14.78,7.45q4.75-2.5,9.7-4.62c1.91-.82,3-1.43,3-1.43s33.31,22,39,53.07,28.23,56.46,28.79,60.41c.36,2.49-4.45,8.12-12.44,13.08C1060.66,500.26,1067.64,492.78,1067.21,489.8Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  d: "M983.16,388.62s14.6,7.23,17.35,21.13",
  transform: "translate(-124.06 -144.92)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  opacity: 0.1
});

var _ref59 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M947.46,352.34c2.33.52,4.93,1.25,6.08,3.34.83,1.52.68,3.43,1.49,5,2.08,3.92,8.18,2.57,12,4.87,7,4.22,2.43,17.38,9.4,21.62,1.31.8,2.86,1.12,4.21,1.85,5.89,3.22,5.06,11.74,4,18.37s.2,15.7,6.85,16.64c3.66.51,7.77-1.91,10.85.12,1.61,1.06,2.34,3,3.69,4.41a6.72,6.72,0,0,0,7.22,1.49c2.26-.94,3.89-3.09,6.24-3.78,3.78-1.11,8,1.95,11.64.54s4.47-6.67,3.53-10.64-2.86-8-1.86-12c.83-3.3,3.53-5.82,4.71-9,3.46-9.39-7.27-19.09-5.29-28.9.86-4.25,4.06-8,4-12.29-.1-5-4.53-8.79-9.14-10.63s-9.67-2.36-14.18-4.41c-9.89-4.5-15.3-15.38-24.34-21.42a34.13,34.13,0,0,0-13.39-5.14,43.9,43.9,0,0,0-34.94,9.5c-.89.72-1.8,1.4-2.72,2.06-3.86,2.79-8,5.54-10.35,9.68C918.58,348.56,938.29,350.27,947.46,352.34Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  d: "M948.16,350.93c2.33.52,4.93,1.25,6.08,3.34.83,1.52.68,3.43,1.49,5,2.08,3.92,8.18,2.57,12,4.87,7,4.22,2.43,17.38,9.4,21.62,1.31.8,2.86,1.12,4.21,1.85,5.89,3.22,5.06,11.74,4,18.37s.2,15.7,6.85,16.64c3.66.51,7.77-1.91,10.85.12,1.61,1.06,2.34,3,3.69,4.41a6.72,6.72,0,0,0,7.22,1.49c2.26-.94,3.89-3.09,6.24-3.78,3.78-1.11,8,1.95,11.64.54s4.47-6.67,3.53-10.64-2.86-8-1.86-12c.83-3.3,3.53-5.82,4.71-9,3.46-9.39-7.27-19.09-5.29-28.9.86-4.25,4.06-8,4-12.29-.1-5-4.53-8.79-9.14-10.63s-9.67-2.36-14.18-4.41c-9.89-4.5-15.3-15.38-24.34-21.42a33.5,33.5,0,0,0-12.1-4.9,43.93,43.93,0,0,0-36.26,9.28c-.88.71-1.79,1.39-2.69,2-3.86,2.79-8,5.54-10.35,9.68C919.28,347.15,939,348.87,948.16,350.93Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M746.9,507.1h-174V474.31C615.41,454.44,680.82,443.28,746.9,507.1Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref62 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M881.9,502.41v4.69h-217v-1S771.68,402.13,881.9,502.41Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M883.9,502.41v4.69h-217v-1S773.68,402.13,883.9,502.41Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref64 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 484.84,
  cy: 215.18,
  r: 16,
  fill: "#4527a0"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  d: "M745.12,348c-1.83,0-3.87,0-5.26.11a6.4,6.4,0,0,0-1.82.37l-9.41,3.38c7.6.19,15.53.13,23.32.07l43.68-.34c4.46,0,9.14-.08,12.85-.34,2.49-.18,4.32-.44,6.62-.64,8.27-.74,20.32-.6,31.09-.56s23.77-.24,27.56-1.32H850.63c-2.49,0-5.11,0-7.31-.12-2.57-.15-4.14-.43-6.4-.63-3.74-.32-8.9-.36-13.7-.38C796.87,347.49,770.85,348.11,745.12,348Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f4f4f4"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  d: "M771,367.38c-.4,0-.84,0-1.14,0a1.39,1.39,0,0,0-.4.08l-2,.73c1.65,0,3.36,0,5.05,0l9.46-.07c1,0,2,0,2.78-.07.54,0,.94-.1,1.43-.14,1.79-.16,4.4-.13,6.74-.12a36.72,36.72,0,0,0,6-.29h-5c-.54,0-1.11,0-1.58,0s-.9-.09-1.39-.14c-.81-.07-1.93-.08-3-.08C782.25,367.28,776.61,367.41,771,367.38Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f4f4f4"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  d: "M704,395.38c-.4,0-.84,0-1.14,0a1.39,1.39,0,0,0-.4.08l-2,.73c1.65,0,3.36,0,5.05,0l9.46-.07c1,0,2,0,2.78-.07.54,0,.94-.1,1.43-.14,1.79-.16,4.4-.13,6.74-.12a36.72,36.72,0,0,0,6-.29h-5c-.54,0-1.11,0-1.58,0s-.9-.09-1.39-.14c-.81-.07-1.93-.08-3-.08C715.25,395.28,709.61,395.41,704,395.38Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f4f4f4"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  d: "M666.41,498.23h-7.52s-2.35-82.24,7.52-107.62h1.88S661.71,483.66,666.41,498.23Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M661.24,386.38s-6.11,16.92-3.29,24.44c0,0,4.23-15.51,9.16-17.86s10.1,17.86,10.1,17.86,2.82-12.69-2.35-23c0,0,10.34,5.64,15.51,16.45,0,0,.94-7-11.28-21.62,0,0,10.81,2.82,17.86,9.4,0,0,2.35-5.17-12.22-13.63,0,0,1.88-6.11,13.16-3.29,0,0,0-8-17.86-6.58,0,0,0-5.17,11.75-4.23,0,0,0-6.58-13.63-4.23,0,0,2.82-4.23,4.7-5.17a9.45,9.45,0,0,0-6.58,1.88s.47-8.46-6.58-11.75l-.94,11.75s-7.9-9.31-6.11-7.52c.47.47,1.88,6.11,1.41,8.93,0,0-8-6.58-17.86.47,0,0,12.22.94,14.1,5.17,0,0-10.34-1.88-12.69-.47,0,0,8,2.82,7.52,4.7,0,0-14.1,0-16,5.17,0,0,14.57,1.88,15.51,3.29,0,0-16.92,12.22-17.86,15.51,0,0,17.39-10.34,20.21-10.34s-12.69,15-11.75,18.8C645.27,400.48,658,385.44,661.24,386.38Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M759.16,495.15h5.74s1.8-62.83-5.74-82.22h-1.44S762.76,484,759.16,495.15Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M763.11,409.7s4.67,12.93,2.51,18.67c0,0-3.23-11.85-7-13.64s-7.72,13.64-7.72,13.64-2.15-9.69,1.8-17.59a31.21,31.21,0,0,0-11.85,12.57s-.72-5.39,8.62-16.52c0,0-8.26,2.15-13.64,7.18,0,0-1.8-3.95,9.34-10.41,0,0-1.44-4.67-10.05-2.51,0,0,0-6.1,13.64-5,0,0,0-3.95-9-3.23,0,0,0-5,10.41-3.23,0,0-2.15-3.23-3.59-3.95a7.22,7.22,0,0,1,5,1.44s-.36-6.46,5-9l.72,9s6-7.11,4.67-5.74a15.75,15.75,0,0,0-1.08,6.82s6.1-5,13.64.36c0,0-9.34.72-10.77,3.95,0,0,7.9-1.44,9.69-.36,0,0-6.1,2.15-5.74,3.59,0,0,10.77,0,12.21,3.95,0,0-11.13,1.44-11.85,2.51,0,0,12.93,9.34,13.64,11.85,0,0-13.28-7.9-15.44-7.9s9.69,11.49,9,14.36C775.32,420.47,765.63,409,763.11,409.7Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M827.89,482.87h3.56s1.11-38.91-3.56-50.92H827S830.11,476,827.89,482.87Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M830.34,429.95s2.89,8,1.56,11.56c0,0-2-7.34-4.34-8.45s-4.78,8.45-4.78,8.45-1.33-6,1.11-10.9a19.33,19.33,0,0,0-7.34,7.78s-.44-3.34,5.34-10.23a22.56,22.56,0,0,0-8.45,4.45s-1.11-2.45,5.78-6.45c0,0-.89-2.89-6.23-1.56,0,0,0-3.78,8.45-3.11,0,0,0-2.45-5.56-2,0,0,0-3.11,6.45-2a9.77,9.77,0,0,0-2.22-2.45,4.47,4.47,0,0,1,3.11.89s-.22-4,3.11-5.56l.44,5.56s3.74-4.4,2.89-3.56a9.75,9.75,0,0,0-.67,4.22,6.93,6.93,0,0,1,8.45.22s-5.78.44-6.67,2.45c0,0,4.89-.89,6-.22,0,0-3.78,1.33-3.56,2.22,0,0,6.67,0,7.56,2.45,0,0-6.89.89-7.34,1.56,0,0,8,5.78,8.45,7.34,0,0-8.23-4.89-9.56-4.89s6,7.12,5.56,8.89C837.9,436.62,831.89,429.5,830.34,429.95Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4527a0"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M697.89,438.87h0l-.75-4a2.17,2.17,0,0,0-.68-1.57l-3.47-1.7,0,0a3.93,3.93,0,0,1-.62-1l.06-.09a2.08,2.08,0,0,0,.4-.81,1.38,1.38,0,0,0,0-.23l.05,0a1.29,1.29,0,0,0,1.43-1v-.09a1.29,1.29,0,0,1-1.17,1,3.54,3.54,0,0,0,1.57-2.94s0-.1,0-.15a1.28,1.28,0,0,0,.59-.86v-.09a1.28,1.28,0,0,1-.61.8,3.52,3.52,0,0,0-.22-1h.09a1.29,1.29,0,0,0,1.29-1.29s0-.06,0-.09a1.29,1.29,0,0,1-1.28,1.2h-.16l0-.06a2.11,2.11,0,0,0,1.48-1.71s0-.06,0-.09a1.28,1.28,0,0,1-.26.69,1.29,1.29,0,0,0-2.54-.38l-.23-.13a1.29,1.29,0,0,1,1.16-.94h-.09a1.29,1.29,0,0,0-1.23.87,3.54,3.54,0,0,0-4.46,1.28c-.27.2-.62.49-.61.74a2.45,2.45,0,0,0-.31.38,4.9,4.9,0,0,0-.4,2.67,2.83,2.83,0,0,1-.92,2.45,1.22,1.22,0,0,0,.94,0,3.62,3.62,0,0,0,.83-.49,1.86,1.86,0,0,0,.59-.57l0-.05a2.92,2.92,0,0,0,.53.28c.07.6.09,1.29-.18,1.52l0,0h0l.05-.11a3.25,3.25,0,0,1-2.25.64,2.81,2.81,0,0,0-2.33,1.5L683.09,438h0l0,.08h0l0,.08h0a.35.35,0,0,0,.26.25l.34.09a7.06,7.06,0,0,1-.23,2.31,19.73,19.73,0,0,0-.39,3.4c.08.57.22,3.54.29,4.95a14.66,14.66,0,0,0-.29,1.46l-1.61,9.66s-1.2,7.73-1.14,10.07l-.21,1.35s-3.27,4.1-2.31,4.68,2.44.83,3.85-1.35a3.53,3.53,0,0,1,.9-1.35,1.32,1.32,0,0,0,.45-1.13l-.1-1,.17.06v0l.1,0s1.61-5.29,1.43-9c0,0,3-10.62,5.25-12.29v-.07l.21-.1.48,10.29-.49,11.34-.11.68s-3.27,4.1-2.31,4.68,2.44.83,3.85-1.35a3.53,3.53,0,0,1,.9-1.35,1.32,1.32,0,0,0,.45-1.13l-.15-1.5c.56-1.91,2-7.41,1.41-10.6l1-6.78c1-1.13.87-4,.87-4,.79-1.65,1-8.12,1-8.12l.2-3.2a2.66,2.66,0,0,1,.45,0l.1,0h.06l0-.06a.3.3,0,0,0,.07-.09l.06,0v-.08h0Zm-2.8,6.5c-.09-.22-.19-.44-.3-.66h-.08l0-.08a.39.39,0,0,1,0-.08l0-.08a2.76,2.76,0,0,0,.12-.33,1.25,1.25,0,0,0,.19-.69A6.54,6.54,0,0,1,695.09,445.37Zm-.3-2.74-.2-2.14.06-.17.27,2.72Zm-9.48.29a.75.75,0,0,0-.18.58s0,0,0,.07a2.43,2.43,0,0,0,.09.64l-.31,1.34,0-2.56a5.66,5.66,0,0,0,.54-.86A1.4,1.4,0,0,1,685.31,442.92Z",
  transform: "translate(-124.06 -144.92)",
  fill: "url(#5a176c23-bf11-4e32-afb4-461b4082aabc)"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M687.33,426.4a4.72,4.72,0,0,0-.39,2.57,2.73,2.73,0,0,1-.89,2.36,1.18,1.18,0,0,0,.91,0,3.49,3.49,0,0,0,.8-.47,1.79,1.79,0,0,0,.57-.55,2.12,2.12,0,0,0,.13-1.09,11.56,11.56,0,0,1,.17-1.95c.06-.4.44-1.49,0-1.7S687.52,426.1,687.33,426.4Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  d: "M680.72,468.91l-.31,2s-3.15,4-2.22,4.51,2.35.8,3.71-1.3a3.4,3.4,0,0,1,.86-1.3h0a1.27,1.27,0,0,0,.43-1.09l-.31-3.05Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#333"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.2,469.7l-.31,2s-3.15,4-2.22,4.51,2.35.8,3.71-1.3a3.4,3.4,0,0,1,.86-1.3h0a1.27,1.27,0,0,0,.43-1.09l-.31-3.05Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#333"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M685.29,445.79s-1.48,1.07-2,4.79l-1.55,9.31s-1.31,8.44-1.07,10.06l2.62.9s1.55-5.1,1.38-8.65c0,0,3.15-11.22,5.36-12l.47,9.91L690,471.26l2.24.45s2.27-7.1,1.55-10.86l1.17-8s1.34-4.27-.52-8Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#4d8af0"
});

var _ref79 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M689.8,450.35v-.17c-2.21.79-5.36,12-5.36,12a31.51,31.51,0,0,1-1.35,8.56l.28.1s1.55-5.1,1.38-8.65C684.74,462.2,687.62,452,689.8,450.35Z",
  transform: "translate(-124.06 -144.92)"
}), React.createElement("path", {
  d: "M694.53,444.9l-.3,0a11.84,11.84,0,0,1,.5,7.93l-1.17,8c.69,3.56-1.32,10.11-1.53,10.8l.29.06s2.27-7.1,1.55-10.86l1.17-8S696.39,448.58,694.53,444.9Z",
  transform: "translate(-124.06 -144.92)"
}));

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,438.5a.33.33,0,0,0,.26.33,5.18,5.18,0,0,1,2,1c1.1.86-1.17-1.72-1.17-1.72l-.76.17-.31.28Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f55f44"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,438.5a.33.33,0,0,0,.26.33,5.18,5.18,0,0,1,2,1c1.1.86-1.17-1.72-1.17-1.72l-.76.17-.31.28Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  d: "M694.1,440.78a7,7,0,0,1,3.12-1.23.29.29,0,0,0,.29-.29h0S694.89,438.23,694.1,440.78Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f55f44"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M697.51,439.25s-2.62-1-3.41,1.52c0,0,1.93-1.48,3.27-1.24",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref84 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 567,
  cy: 282.28,
  r: 3.41,
  fill: "#72351c"
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M688.71,429.59s.48,2,0,2.41-1.45,1.17-.72,1.76,3.34,1.59,4.21,1.1,1.86-.34,1.62-1.34-2.14-.79-2.17-5.76Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.88,437.9a12.48,12.48,0,0,1-.21,3.24,19,19,0,0,0-.38,3.27c.1.72.31,5.48.31,5.48s-.38,4.17,1.65,3.79-.31-4.76-.31-4.76l.1-5.69a5.31,5.31,0,0,0,1-2.55C686.19,439.31,683.88,437.9,683.88,437.9Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.85,437.9a12.48,12.48,0,0,1-.21,3.24,19,19,0,0,0-.38,3.27c.1.72.31,5.48.31,5.48s-.38,4.17,1.65,3.79-.31-4.76-.31-4.76l.1-5.69a5.31,5.31,0,0,0,1-2.55C686.15,439.31,683.85,437.9,683.85,437.9Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M696.84,438.21l-.28,4.45s-.17,6.24-.93,7.82c0,0,.21,4.38-1.83,4.27s.34-4.79.34-4.79,1.09-4.87.53-6.41l-.53-5.34Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M696.87,438.21l-.28,4.45s-.17,6.24-.93,7.82c0,0,.21,4.38-1.83,4.27s.34-4.79.34-4.79,1.09-4.87.53-6.41l-.53-5.34Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#fdb797"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.26,433.9s1.65.76,2.55-1.5l3.35,1.64a2.09,2.09,0,0,1,.65,1.52l.72,3.86s-2.45-.83-3.21,1.45l.21,2.17v0a2.34,2.34,0,0,1-.11,1.62.36.36,0,0,0,0,.29,1.06,1.06,0,0,1-1,1.38,20.33,20.33,0,0,0-2.69.21c-.72.21-2.9-.41-3.62,0s-2.24-.31-2.24-.31l.41-1.76s-.28-.86.07-1.17.14-3-.17-3.76c0,0-1.24-1.17-2-1l1-4.45a2.7,2.7,0,0,1,2.24-1.45,3.14,3.14,0,0,0,2.17-.62S687.84,433.66,690.26,433.9Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.43,433.82c.45.12,1.65.25,2.37-1.56l3.35,1.64a2.09,2.09,0,0,1,.65,1.52l.72,3.86s-2.45-.83-3.21,1.45l.21,2.17.14.43a1.23,1.23,0,0,1-.17,1.1.39.39,0,0,0-.07.4,1.06,1.06,0,0,1-1,1.38,20.33,20.33,0,0,0-2.69.21c-.72.21-2.9-.41-3.62,0s-2.24-.31-2.24-.31l.41-1.76s-.28-.86.07-1.17.14-3-.17-3.76c0,0-1.24-1.17-2-1l1-4.45a2.7,2.7,0,0,1,2.24-1.45,3.14,3.14,0,0,0,2.17-.62s-.81,1.48,1.32,1.8Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.43,433.89c.45.12,1.65.25,2.37-1.56l3.35,1.64a2.09,2.09,0,0,1,.65,1.52l.72,3.86s-2.45-.83-3.21,1.45l.21,2.17v0a2.34,2.34,0,0,1-.11,1.62.36.36,0,0,0,0,.29,1.06,1.06,0,0,1-1,1.38,20.33,20.33,0,0,0-2.69.21c-.72.21-2.9-.41-3.62,0s-2.24-.31-2.24-.31l.41-1.76s-.28-.86.07-1.17.14-3-.17-3.76c0,0-1.24-1.17-2-1l1-4.45a2.7,2.7,0,0,1,2.24-1.45,3.14,3.14,0,0,0,2.17-.62s-.81,1.48,1.32,1.8Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f55f44"
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.7,427.94l-2.93,1.83a9.52,9.52,0,0,1,.17,1,2.82,2.82,0,0,0,1.05.2,3,3,0,0,0,1.9-.86A11.39,11.39,0,0,1,691.7,427.94Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref94 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 565.87,
  cy: 283,
  r: 2.83,
  fill: "#fdb797"
});

var _ref95 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 570.04,
  cy: 279.59,
  r: 1.24,
  fill: "#72351c"
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M694.34,425.82a1.24,1.24,0,0,1-1.24-1.15s0,.06,0,.09a1.24,1.24,0,1,0,2.48,0s0-.06,0-.09A1.24,1.24,0,0,1,694.34,425.82Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  d: "M693.63,427a1.24,1.24,0,0,1-1-1.36l0,.08a1.24,1.24,0,1,0,2.44.45v-.09A1.24,1.24,0,0,1,693.63,427Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M692.67,430a1.24,1.24,0,0,1-1-1.36l0,.08a1.24,1.24,0,0,0,2.44.45v-.09A1.24,1.24,0,0,1,692.67,430Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  d: "M694.34,425.16A1.24,1.24,0,0,1,693.1,424s0,.06,0,.09a1.24,1.24,0,1,0,2.48,0s0-.06,0-.09A1.24,1.24,0,0,1,694.34,425.16Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  d: "M692.61,424.49a1.24,1.24,0,0,1,1.17-1.23h-.09a1.24,1.24,0,0,0,0,2.48h.09A1.24,1.24,0,0,1,692.61,424.49Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  d: "M693.86,436.19a4.47,4.47,0,0,1,0,1.86s-.17,1.62.1,1.9",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M685.48,436.57a4.47,4.47,0,0,1,0,1.86s-.17,1.62.1,1.9",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M685.41,443.22a1.23,1.23,0,0,0,.83,0,1.72,1.72,0,0,1,1,0",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  d: "M685.83,440.78a7.15,7.15,0,0,0,2.86-.45s3.52.86,4.52.24",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref105 =
/*#__PURE__*/
React.createElement("rect", {
  x: 559.21,
  y: 310.72,
  width: 2.17,
  height: 1.34,
  rx: 0.67,
  ry: 0.67,
  fill: "#fdb797"
});

var _ref106 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,456l1.16-.05,1,.16h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.1,450.39l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref108 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.1,450.63l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.1,450.88l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.1,451.12l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref111 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,456.93l1.16,0,1,.12h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,456.81l1.16,0,1,.12h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref113 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,456.69l1.16,0,1,.12h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref114 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,456.57l1.16,0,1,.12h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref115 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,455.82l1.16-.05,1,.16h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref116 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.28,455.61l1.16-.05,1,.16h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref117 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.41,426.11a6.84,6.84,0,0,0,.4,3.12,3.71,3.71,0,0,1-.15,3,1,1,0,0,0,.88-.22,3.41,3.41,0,0,0,.64-.75,2,2,0,0,0,.39-.78,3.09,3.09,0,0,0-.2-1.32,17,17,0,0,1-.42-2.33c-.06-.48,0-1.86-.54-2S690.51,425.71,690.41,426.11Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref118 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.48,426.08a6.84,6.84,0,0,0,.4,3.12,3.71,3.71,0,0,1-.15,3,1,1,0,0,0,.88-.22,3.41,3.41,0,0,0,.64-.75,2,2,0,0,0,.39-.78,3.09,3.09,0,0,0-.2-1.32,17,17,0,0,1-.42-2.33c-.06-.48,0-1.86-.54-2S690.58,425.67,690.48,426.08Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref119 =
/*#__PURE__*/
React.createElement("path", {
  d: "M689.26,426.82c.24.25.29.62.49.9a1.77,1.77,0,0,0,1.4.56.79.79,0,0,1,.41.09c.22.14.23.46.37.68a.8.8,0,0,0,1.17,0,1.93,1.93,0,0,0,.45-1.23,7.7,7.7,0,0,0,0-1.49,2.28,2.28,0,0,0-.63-1.52,2.66,2.66,0,0,0-1.11-.48,3.29,3.29,0,0,0-1.71-.13,3.08,3.08,0,0,0-.78.39q-.51.33-1,.67c-.37.26-1.07.78-.39,1.06C688.36,426.52,688.9,426.43,689.26,426.82Z",
  transform: "translate(-124.06 -144.92)",
  opacity: 0.1
});

var _ref120 =
/*#__PURE__*/
React.createElement("path", {
  d: "M689.33,426.78c.24.25.29.62.49.9a1.77,1.77,0,0,0,1.4.56.79.79,0,0,1,.41.09c.22.14.23.46.37.68a.8.8,0,0,0,1.17,0,1.93,1.93,0,0,0,.45-1.23,7.7,7.7,0,0,0,0-1.49,2.28,2.28,0,0,0-.63-1.52,2.66,2.66,0,0,0-1.11-.48,3.29,3.29,0,0,0-1.71-.13,3.08,3.08,0,0,0-.78.39q-.51.33-1,.67c-.37.26-1.07.78-.39,1.06C688.43,426.48,689,426.4,689.33,426.78Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#72351c"
});

var _ref121 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.17,450.39l1.16,0,1,.1H693Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.17,450.63l1.16,0,1,.1H693Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref123 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.17,450.88l1.16,0,1,.1H693Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref124 =
/*#__PURE__*/
React.createElement("path", {
  d: "M691.17,451.12l1.16,0,1,.1H693Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.67,464.39l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref126 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.67,464.64l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref127 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.67,464.88l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var _ref128 =
/*#__PURE__*/
React.createElement("path", {
  d: "M690.67,465.12l1.16,0,1,.1h-.35Z",
  transform: "translate(-124.06 -144.92)",
  fill: "#f0e4e4"
});

var SvgUndrawWebsiteSetup5Hr2 = function SvgUndrawWebsiteSetup5Hr2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "9c167f13-7fe2-4e7b-a8cb-8bb79342b68a",
    "data-name": "Layer 1",
    width: 951.84,
    height: 610.17,
    viewBox: "0 0 951.84 610.17",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawWebsiteSetup5Hr2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_website_setup_5hr2.78b849dc.svg";
export { ForwardRef as ReactComponent };